import { type SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod/v4';

import { Button, TextInput } from '@engecomp/shared/components';
import { useUserContext } from '@engecomp/shared/contexts';

import LogoIcon from '@engecomp/shared/icons/logo.svg';

import styles from './index.module.css';

const schema = z.object({
  email: z.string().min(1, { message: 'obrigatório' }),
  code: z.string().min(1, { message: 'obrigatório' }),
  confirmPassword: z.string().min(1, { message: 'obrigatório' }),
  password: z.string().min(1, { message: 'obrigatório' }),
});

export type Schema = z.infer<typeof schema>;

export function PasswordRecovery() {
  const { resetPassword } = useUserContext();
  const navigate = useNavigate();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<Schema>({ resolver: zodResolver(schema) });

  const onSubmit: SubmitHandler<Schema> = async (recoverPasswordData) => {
    const success = await resetPassword(recoverPasswordData);

    if (success) {
      toast.success('Senha alterada com sucesso!');
      navigate('/auth/login');
    } else {
      toast.error('Não foi possível alterar a senha. Verifique os dados e tente novamente.');
    }
  };

  return (
    <>
      <header className={styles.ForgotPassword_Header}>
        <img src={LogoIcon} alt='logo' />
      </header>

      <div className={styles.ForgotPassword_Title}>
        <p>Recuperação de Senha</p>
      </div>

      <div className={styles.ForgotPassword_SubTitle}>
        <p>
          Aqui você poderá criar sua nova senha! Assim que concluir, <br />
          você será redirecionado a sua dashboard do MyTeam.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.fieldsForm}>
          <div className={styles.fields}>
            <TextInput
              style={{ overflow: 'hidden' }}
              label='E-mail:'
              placeholder='E-mail'
              field='email'
              type='email'
              errors={errors}
              {...{ register }}
            />
            <TextInput
              style={{ overflow: 'hidden' }}
              label='Code:'
              placeholder='Código'
              field='code'
              errors={errors}
              {...{ register }}
            />
          </div>

          <div className={styles.fields}>
            <TextInput
              style={{ overflow: 'hidden' }}
              label='Nova Senha:'
              placeholder='Nova Senha'
              field='password'
              errors={errors}
              {...{ register }}
            />
            <TextInput
              style={{ overflow: 'hidden' }}
              label='Confirmar Senha:'
              placeholder='Confirmar senha'
              field='confirmPassword'
              errors={errors}
              {...{ register }}
            />
          </div>
        </div>

        <div className={styles.button}>
          <Button type='submit'>Alterar senha</Button>
        </div>
      </form>
    </>
  );
}
